
import { z } from "zod";
import { isValidPhoneNumber } from 'libphonenumber-js';

export interface WhatsAppPromoProps {
  isOpen?: boolean;
  onClose?: () => void;
  autoShow?: boolean;
}

export interface CountryOption {
  code: string;
  name: string;
}

export const formSchema = z.object({
  countryCode: z.string().min(1, "Please select a country"),
  phoneNumber: z.string()
    .min(1, "Phone number is required")
    .refine((val) => /^\d+$/.test(val), "Please enter only numbers"),
  email: z.string().email("Please enter a valid email address"),
  receiveUpdates: z.boolean().default(true)
}).superRefine((data, ctx) => {
  if (data.countryCode && data.phoneNumber) {
    try {
      const fullNumber = `${data.countryCode}${data.phoneNumber}`;
      const isValid = isValidPhoneNumber(fullNumber);
      
      if (!isValid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Please enter a valid phone number for the selected country",
          path: ["phoneNumber"]
        });
      }
    } catch {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Invalid phone number format",
        path: ["phoneNumber"]
      });
    }
  }
});

export type FormValues = z.infer<typeof formSchema>;
